import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const AccountsService = {
  getAccounts: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts`);
  },
  saveAccount: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts`, data);
  },
  editAccount: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts`, data);
  },
  getUsers: (data: { companyId: string }) => {
    const { companyId } = data;
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}users/${companyId}`);
  },
  getAccountsForCompany: (data: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/${data}`, {
      params: { data }
    });
  },
  deactivateAccount: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/deactivate`, data);
  },
  activateAccount: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/activate`, data);
  },
  updateWAChannel: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/channels/whatsapp`, data);
  },
  updateRCSChannel: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/channels/rcs`, data);
  },
  updateSMSChannel: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/channels/sms`, data);
  },
  updateMailingChannel: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/channels/mailing`, data);
  },
  getChannelsForAccount: (accountId: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/channels/${accountId}`);
  },
  getWaAccountsForCompany: (companyId: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/whatsapp/${companyId}`);
  },
  getRCSAccountsForCompany: (companyId: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/rcs/${companyId}`);
  }
};
